import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';

import { UsersResourceService } from './users-resource.service';
import { ApiResourceModule } from '../api-resource/api-resource.module';

@NgModule({
  exports: [],
  declarations: [],
  imports: [ApiResourceModule],
  providers: [
    UsersResourceService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class UsersResourceModule {}
